// extracted by mini-css-extract-plugin
module.exports = {"key-forge-animation":"KeyForgeAnimation_key-forge-animation__mudGa"};